"use client";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

import { PropsWithChildren, useEffect, useState } from "react";

export default function HashContainer(
  props: PropsWithChildren<{
    hash?: string;
    defaultHash?: string;
  }>
) {
  const [currentHash, setCurrentHash] = useState<string>();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleHashChange = () => {
        setCurrentHash(window.location.hash.slice(1) || props.defaultHash);
      };

      handleHashChange();

      window.addEventListener("hashchange", handleHashChange);

      return () => {
        window.removeEventListener("hashchange", handleHashChange);
      };
    }
  }, [props.defaultHash]);

  return (
    <div
      className={cn("relative hidden", {
        block: currentHash === props.hash,
      })}>
      {!currentHash && (
        <div className="flex h-[200px] items-center justify-center">
          <Loader2 className="animate-spin text-primary" size={50} />
        </div>
      )}
      {props.children}
    </div>
  );
}
